
<div class="relative">
  <app-button 
    #legendBtn
    [type]="type"
    class="opacity-0"
    (event)="toggleContainer()"
  >
      <svg ngProjectAs="icon" class="text-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.842 13.999">
          <g id="Icon_ion-help-outline" data-name="Icon ion-help-outline" transform="translate(-10.468 -5.155)">
              <path id="Trazado_104" data-name="Trazado 104" d="M11.25,8.952a3.387,3.387,0,0,1,1.277-2.264A3.733,3.733,0,0,1,14.9,5.906a4.131,4.131,0,0,1,1.731.3A3.069,3.069,0,0,1,18.56,8.952c0,1.739-1.111,2.527-2.374,3.4a3.025,3.025,0,0,0-1.586,2.7" transform="translate(0 0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
              <path id="Trazado_105" data-name="Trazado 105" d="M17.624,27.093a1.218,1.218,0,1,1-1.218-1.218A1.218,1.218,0,0,1,17.624,27.093Z" transform="translate(-1.806 -9.157)" fill="currentColor"/>
          </g>
      </svg>
  </app-button>

  <div #legendContent class="absolute right-0 top-12 z-10 flex flex-col bg-black rounded-3xl p-5 opacity-0 hidden pointer-events-none">
    <span class="text-sm text-white text-center whitespace-nowrap">
      Site Version: v{{ version }}
    </span>
  </div>
</div>
